import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {requestVerifyEmail} from "../_redux/authCrud";
import {useAlert} from "react-alert";
import {useHistory} from "react-router-dom";

function EmailVerify(props) {
	const {params} = props.match
	const {t} = useTranslation('common')
	const alert = useAlert()
	const history = useHistory()

	const [email,setEmail] = useState('')
	const [requestLoading,setRequestLoading] = useState(false)
	const [timer,setTimer] = useState(0)

	useEffect(()=>{
		if(timer <= 0) return ;
		setTimeout(()=>{
			setTimer(p=>{
				if(p === 1) setRequestLoading(false)
				return p-1
			})
		},1000)
	},[timer])

	const requestEmail = async () => {
		setRequestLoading(true)
		const rEmail = params.email ? params.email : ''
		if(!rEmail) {
			setRequestLoading(false)
			return alert.error('ایمیل خود را وارد کنید .')
		}
		requestVerifyEmail(rEmail,t('lang'))
			.then(({ data}) => {
				if (data.success) {
					if(data.verified){
						alert.success('حساب شما قبلا تایید شده به صفحه ورود منتقل می شوید.')
						setTimeout(()=>{
							history.push(`/auth/login`)
						},500)
					}else{
						alert.success('ایمیل تایید ارسال شد.')
						setTimer(180) //3min timer
					}
				} else {
					alert.error('مشکلی پیش آمد دوباره تلاش کنید.')
					setRequestLoading(false)
				}
			})
			.catch(() => {
				alert.error('مشکلی پیش آمد دوباره تلاش کنید.')
				setRequestLoading(false)
			})
	}
	return (
		<div className="login-form login-signin" id="kt_login_signin_form">
			{/* begin::Head */}
			<div className="text-center mb-10 mb-lg-20">
				<h3 className="font-size-h1">
					{t('AUTH.VERIFY.EMAIL')}
				</h3>
			</div>
			{/* end::Head */}

			{/*begin::Form*/}
			<div
				className="fv-plugins-bootstrap fv-plugins-framework"
			>
				<div className="mb-4 alert alert-custom alert-light-primary alert-dismissible card alert-shadow">
						<span className="alert-text font-weight-bold text-center" style={{direction:'rtl'}}>
							برای ورود لطفا لینک ارسال شده به ایمیل خود را باز کنید .
						</span>
				</div>
				<div className="mb-20 alert alert-custom alert-dismissible card alert-shadow">
					<span
						className='alert-text font-weight-bold text-center'>{params.email ? params.email : 'YourEmail@domain.com'}</span>
				</div>

				<div>
					{timer ?
						<div className="timeline-badge">{timer} ثانیه </div>
						:
						""
					}
					{/* <input className='form-control form-control-solid h-auto px-6 py-5' type='email' value={email} onChange={(e)=>setEmail(e.target.value)} placeholder={params.email ? window.atob(params.email) : 'YourEmail@domain.com'}/> */}
					<button onClick={requestEmail} disabled={requestLoading} id="kt_login_signin_submit" type="button"
									className="btn btn-primary font-weight-bold my-3 px-9 py-4 w-100">
						<span>ارسال مجدد</span>
						{requestLoading && <span className="blockui m-1 ml-3 spinner spinner-white"/>}
					</button>
					<p className="text-dark-75" style={{direction:'rtl'}} >در صورت عدم دریافت حتما پوشه Junk/Spam خود را چک کرده یا درخواست ارسال مجدد را
						بزنید.</p>
				</div>
			</div>
			{/*end::Form*/}
		</div>
	);
}

export default (EmailVerify);
